// -------------------------------------------
//   ANIMATIONS > SHAKE
// -------------------------------------------
import { replacePXinStringWithEM } from 'utils/styles/style_helpers';



// (((((((((( ~~~~~~~~~~ SHAKE ~~~~~~~~~~ )))))))))) //
const shake = {
	'@global': {
		// ***** SHAKE ***** //
		'@keyframes shake': {
			'from, to': {
				transform: 'translate3d(0, 0, 0)'
			},
			'10%, 30%, 50%, 70%, 90%': {
				transform: replacePXinStringWithEM('translate3d(-10px, 0, 0)')
			},
			'20%, 40%, 60%, 80%': {
				transform: replacePXinStringWithEM('translate3d(10px, 0, 0)')
			}
		}
	}
};


// (((((((((( ~~~~~~~~~~ HEAD SHAKE ~~~~~~~~~~ )))))))))) //
const headShake = {
	'@global': {
		// ***** HEAD SHAKE ***** //
		'@keyframes headShake': {
			'0%': {
				transform: 'translateX(0)',
			},
			'6.5%': {
				transform: replacePXinStringWithEM('translateX(-6px) rotateY(-9deg)'),
			},
			'18.5%': {
				transform: replacePXinStringWithEM('translateX(5px) rotateY(7deg)'),
			},
			'31.5%': {
				transform: replacePXinStringWithEM('translateX(-3px) rotateY(-5deg)')
			},
			'43.5%': {
				transform: replacePXinStringWithEM('translateX(2px) rotateY(3deg)')
			},
			'50%': {
				transform: 'translateX(0)'
			}
		}
	}
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export { shake, headShake };